import moment from 'moment';
import { getUnderperformingAssets } from '@api/autoInsights';
import { get } from 'lodash';
import {
  formatName,
  formatRootCause,
  formatRootCauseValue,
  formatSessions,
  formatImpactedUnique,
} from './formatter';
import { MAX_LIMIT } from './Insights';

const TS_FORMAT = 'MMM DD HH:mm';

// round off to nearest day or hour
export const getEndTime = (arg = 'day') => {
  if (arg === 'hour') {
    return moment().startOf('hour').format();
  }
  return moment().subtract(1, 'day').endOf('day').format();
};

export const getDisplayInterval = (duration) => {
  const to = moment(getEndTime('hour'));
  const from = moment(to).subtract(duration, 'days');

  return {
    from: from.format(TS_FORMAT),
    to: to.format(TS_FORMAT),
  };
};

export async function generateBrokenAssetExportData() {
  const to = getEndTime('hour');
  const resp = await getUnderperformingAssets({
    params: {
      to,
      limit: MAX_LIMIT,
    },
  });
  const { brokenAssets = [] } = get(resp, 'data.response.brokenAssetsData', {});

  const config = {
    page: {
      key: 'broken-asset',
      title: 'Broken Asset',
    },
    sections: [
      {
        key: 'broken-asset',
        title: 'Broken Asset',
      },
    ],
  };

  const exportData = {
    sections: {
      'broken-asset': {
        'broken-asset': {
          data: brokenAssets.map((item) => {
            const { dimension, metrics, rootcause } = item;
            return {
              exportRootCause: formatName(dimension.OBJECT_NAME),
              exportMetricName: `${formatRootCause(rootcause)}`,
              exportMetricValue: `${formatRootCauseValue(rootcause, metrics)}%`,
              exportImpactedUniqueDevices: formatImpactedUnique(metrics),
              exportSessions: formatSessions(metrics),
            };
          }),
          headers: [
            {
              title: 'Root Cause',
              key: 'exportRootCause',
            },
            {
              title: 'Metric Name',
              key: 'exportMetricName',
            },
            {
              title: 'Metric Value',
              key: 'exportMetricValue',
            },
            {
              title: 'Impacted Unique Devices',
              key: 'exportImpactedUniqueDevices',
            },
            {
              title: 'Sessions',
              key: 'exportSessions',
            },
          ],
          widgetInfo: {
            title: `Auto Insights Broken Asset Export ${to}`,
          },
        },
      },
    },
  };

  return {
    config,
    exportData,
  };
}
